import { Box, styled } from '@mui/material';
import { ArrowForwardIosRounded } from '@mui/icons-material';
import clsx from 'clsx';
import React, { ReactElement, ReactNode } from 'react';

export interface ForwardButtonProps {
  onClick?: () => void;
  children?: ReactNode;
  className?: string;
  classes?: Partial<Record<'root' | 'arrow', string>>;
}

export const ForwardButton = styled(
  ({
    onClick,
    children,
    className,
    classes: propClasses = {},
  }: ForwardButtonProps): ReactElement => {
    return (
      <Box
        sx={{
          background: '#fff',
          border: theme => `1px solid ${theme.palette.neutral.darkest}`,
          borderRadius: 16,
          height: 32,
          minWidth: 32,
          cursor: 'pointer',
          outline: 'none',
          '&:focus-visible': {
            outline: theme => `2px auto ${theme.palette.primary.main}`,
            outlineOffset: 6,
          },
        }}
        className={clsx(className, propClasses.root)}
        tabIndex={0}
        onClick={onClick}
        onKeyPress={e => {
          if (e.key === ' ' || e.key === 'Enter') {
            onClick?.();
            e.preventDefault();
          }
        }}
        display="flex"
        alignItems="center"
        lineHeight={children ? 1 : 0}
        pr={children ? 10 : 0}
        role="button"
      >
        <Box ml={10} sx={{ '& .arrow': { fontSize: '0.8125em' } }}>
          {children}
          <ArrowForwardIosRounded
            className={clsx('arrow', propClasses.arrow)}
          />
        </Box>
      </Box>
    );
  },
)``;
